import AssignmentsListPageContainer from './containers/AssignmentsListPageContainer'

export default AssignmentsListPageContainer
